// src/Login.js
import React, { useState } from "react"
import { post } from "./../utils/apiClient"
//import Cookies from "js-cookie"
import "./../css/login.css" // Import the CSS file for styling
import FormsLogo from "../images/efax.svg"

const Login = ({ onLogin }) => {
  const [email, setUsername] = useState("")
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false) // Track loading state

  const ssoLookUp = async () => {
    try {
      setLoading(true)

      let loginUrl = "/oauth/testLogin"
      if (process.env.REACT_APP_ENV === "production") {
        loginUrl = "/oauth/lookup"
      }

      const data = await post(loginUrl, {
        email: email?.trim().toLowerCase(),
      })

      // Redirect if needed
      if (data?.redirect_url) {
        window.location.href = data.redirect_url
      } else {
        setLoading(false) // Set loading to false when done
        setError("Invalid user! Please enter correct email.")
      }
    } catch (err) {
      setError("Invalid user! Please enter correct email.")
      setLoading(false) // Stop loading on error
    }
  }

  const handleGo = (e) => {
    e.preventDefault()
    if (!validateEmail(email?.trim())) {
      setError("Please enter a valid email address.")
      return
    } else {
      setError("")
    }

    if (email) {
      ssoLookUp()
    }
  }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  // Show a loading indicator or error message
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-message">Loading...</div>
      </div>
    ) // You can customize this loading message
  }

  return (
    <>
      <div className="header-container">
        {/* <div className="logo-container">
          <img src={FormsLogo} height={36} width={200} alt="Consensus Logo" />
        </div> */}
        <div className="logo-container">
          <img src={FormsLogo} height={36} width={200} alt="Consensus Logo" />
          <div
            className="logo-label"
            style={{ color: "#FF0000", padding: "0px 5px" }}
          >
            |
          </div>
          <div className="logo-label">BSWH</div>
        </div>
      </div>
      <div className="login-container">
        <h2>BSWH Portal</h2>
        <form onSubmit={handleGo} className="login-form">
          <div className="form-group">
            <label>
              Email:
              <input
                type="text"
                value={email}
                onChange={(e) => {
                  setUsername(e.target.value)
                }}
                className="input-field"
              />
            </label>
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="login-button">
            Go
          </button>
        </form>
      </div>
    </>
  )
}

export default Login
